import { render, staticRenderFns } from "./rentHouseDetail.vue?vue&type=template&id=55bc8bc6&scoped=true&"
import script from "./rentHouseDetail.vue?vue&type=script&lang=js&"
export * from "./rentHouseDetail.vue?vue&type=script&lang=js&"
import style0 from "./rentHouseDetail.vue?vue&type=style&index=0&id=55bc8bc6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc8bc6",
  null
  
)

export default component.exports